"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoSyncPlugin = exports.verticalLinePlugin = void 0;
/**
 * Plugin to draw a vertical line at the x position of the tooltip
 */
exports.verticalLinePlugin = {
    id: 'verticalLine',
    beforeDatasetDraw: function (chart) {
        var ctx = chart.ctx, tooltip = chart.tooltip, xAxes = chart.scales.xAxes, _a = chart.chartArea, top = _a.top, bottom = _a.bottom;
        if (!tooltip || tooltip.opacity === 0) {
            return;
        }
        var x = xAxes.getPixelForValue(tooltip.dataPoints[0].dataIndex);
        // draw a vertical line at the x position of the tooltip
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, top);
        ctx.lineTo(x, bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#b3b3b3';
        ctx.stroke();
        ctx.restore();
    },
};
/**
 * Plugin to sync the graph with the video player, by adjusting the graph size to the video's progress bar dimensions,
 * and drawing a vertical line from the slider handle through the graph
 */
exports.videoSyncPlugin = {
    id: 'videoSync',
    afterDatasetDraw: function (chart) {
        var _a = chart.chartArea, left = _a.left, right = _a.right, canvas = chart.canvas;
        var paddingLeft = left;
        var paddingRight = canvas.clientWidth - right;
        var containerElement = canvas.parentElement.parentElement;
        var graphElement = containerElement.querySelector('.ui-line-graph');
        var sliderElement = containerElement.querySelector('.ui-video-player-controls > .ui-slider');
        if (sliderElement) {
            // set padding to align with progress bar
            var progressBarStartsAt = ((sliderElement === null || sliderElement === void 0 ? void 0 : sliderElement.getBoundingClientRect().left) || 0) - containerElement.getBoundingClientRect().left;
            var progressBarEndsAt = ((sliderElement === null || sliderElement === void 0 ? void 0 : sliderElement.getBoundingClientRect().right) || 0) - containerElement.getBoundingClientRect().left;
            graphElement.style.paddingLeft = "".concat(progressBarStartsAt - paddingLeft - 1, "px");
            graphElement.style.paddingRight = "".concat(containerElement.clientWidth - progressBarEndsAt - paddingRight + 1, "px");
            // draw vertical line from slider handle through the graph
            var handleElement = sliderElement.querySelector('.ui-slider-handle');
            handleElement.innerHTML = '';
            var line = document.createElement('div');
            line.setAttribute('class', 'ui-slider-line');
            line.style.height = "".concat(canvas.clientHeight + 40, "px");
            handleElement.appendChild(line);
        }
    },
};
